export const IMAGE_HEADER_MAIN_GRADIENT =
  "bg-gradient-to-b from-background/20 via-background/35 to-background/50";

export const IMAGE_HEADER_EFFECT_GRADIENT =
  "bg-gradient-to-b from-background/50 to-background-foreground";
